<template functional>
    <section :class="['vf-announce-layout', data.staticClass, data.class]">
        <slot name="header" />
        <div
            :class="[
                'vf-x-tight-vertical-margin-gap',
                {
                    'vf-x-tight-margin-top':
                        props.size === injections.SIZES.SMALL,
                    'vf-x-loose-margin-top':
                        props.size === injections.SIZES.LARGE
                }
            ]"
        >
            <h2
                v-if="props.title"
                class="vf-announce-layout__title vf-subheading-text"
            >
                {{ props.title }}
            </h2>
            <p
                v-if="props.subtitle"
                class="vf-announce-layout__subtitle vf-primary-text"
            >
                {{ props.subtitle }}
            </p>
        </div>
        <slot name="footer" />
    </section>
</template>

<script>
import { SIZES } from 'design-assets/constants/sizes.js';
import VueTypes from 'commons/util/vue-types.js';

const VALID_SIZES = [ SIZES.SMALL, SIZES.LARGE ];

export default {
    props: {
        title: VueTypes.string,
        subtitle: VueTypes.string,
        size: VueTypes.oneOf(VALID_SIZES).def(SIZES.LARGE),
    },
    inject: {
        SIZES: { default: SIZES },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../css/variables/module';

.vf-announce-layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
</style>
